"use client";

import { useEffect, useState } from "react";

const WINDOW_MS = 2000;
const MIN_DT_SEC = 0.3;

type Sample = { t: number; loaded: number; key: string };

export function useTransferRate(
  loaded: number,
  active: boolean,
  key = "",
): number | null {
  const [samples, setSamples] = useState<Sample[]>([]);

  useEffect(() => {
    const id = window.setTimeout(() => {
      if (!active) {
        setSamples((prev) => (prev.length === 0 ? prev : []));
        return;
      }
      const now = performance.now();
      setSamples((prev) => {
        const base = prev[0]?.key === key ? prev : [];
        const last = base[base.length - 1];
        const next =
          last && last.loaded === loaded
            ? base
            : [...base, { t: now, loaded, key }];
        return next.filter((s) => s.t >= now - WINDOW_MS);
      });
    }, 0);
    return () => window.clearTimeout(id);
  }, [loaded, active, key]);

  if (!active || samples.length < 2 || samples[0].key !== key) return null;
  const first = samples[0];
  const last = samples[samples.length - 1];
  const dt = (last.t - first.t) / 1000;
  const delta = last.loaded - first.loaded;
  if (dt < MIN_DT_SEC || delta <= 0) return null;
  return delta / dt;
}
